module.exports = function() {
  return new Worker(__webpack_public_path__ + "dc2a890bd46ee1aa1463.worker.js");
};